import React from "react";
import redVehicle from "src/assets/images/containers/1.png";
import yellowVehicle from "src/assets/images/containers/2.png";
import blueVehicle from "src/assets/images/containers/3.png";
import greenVehicle from "src/assets/images/containers/4.png";
import blackVehicle from "src/assets/images/containers/5.png";
import orangeVehicle from "src/assets/images/containers/6.png";
import cyanVehicle from "src/assets/images/containers/7.png";
import emptyImg from "src/assets/images/empty.png";
import { Theme, makeStyles } from "@material-ui/core/styles";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";
import moment from "moment";

type Props = { slotItem?: any; onClickEvent?: any; colorCode?: number; index?: number };

export const minutesToDhms = (min: string) => {
  const minutes = Number(min);
  const d = Math.floor(minutes / (60 * 24));
  const h = Math.floor((minutes % (60 * 24)) / 60);
  const m = Math.floor((minutes % (60 * 24)) % 60);
  const dDisplay = d > 0 ? `${d}d ` : "";
  const hDisplay = h > 0 ? `${h}h ` : "";
  const mDisplay = m > 0 ? `${m}m ` : d > 0 || h > 0 ? "" : "<1m";
  return dDisplay + hDisplay + mDisplay;
};

export default function VehicleImages({ slotItem, onClickEvent, colorCode }: Props) {
  let vehicleImageType: any;
  switch (colorCode) {
    case 1:
      vehicleImageType = redVehicle;
      break;
    case 2:
      vehicleImageType = yellowVehicle;
      break;
    case 3:
      vehicleImageType = blueVehicle;
      break;
    case 4:
      vehicleImageType = greenVehicle;
      break;
    case 5:
      vehicleImageType = blackVehicle;
      break;
    case 6:
      vehicleImageType = orangeVehicle;
      break;
    case 7:
      vehicleImageType = cyanVehicle;
      break;

    default:
      vehicleImageType = emptyImg;
      break;
  }
  const useStylesBootstrap = makeStyles((theme: Theme) => ({
    arrow: {
      color: theme.palette.common.black,
    },
    tooltip: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  function BootstrapTooltip(props: TooltipProps) {
    const classes = useStylesBootstrap();

    return <Tooltip arrow classes={classes} {...props} />;
  }

  return (
    <>
      <BootstrapTooltip
        title={
          <React.Fragment>
            <h3 style={{ marginBottom: "5px" }}>Container number : {slotItem?.containerNo}</h3>
            <h3>Type of consignment : {slotItem?.consignmentType}</h3>
            <h3>Type of cargo : {slotItem?.cargoType}</h3>
            <h3>
              Yard stay time :{" "}
              {slotItem?.vehicleInYardMinutes ? minutesToDhms(slotItem?.vehicleInYardMinutes) : ""}
            </h3>{" "}
            <h3>
              Entry date & time :{" "}
              {moment(new Date(slotItem?.yardDateTime)).format("DD/MM/YYYY hh:mm a")}
            </h3>
          </React.Fragment>
        }
      >
        <input
          type="image"
          src={vehicleImageType}
          alt="logo"
          onClick={onClickEvent}
          style={{ height: "28px", width: "52px" }}
        />
      </BootstrapTooltip>
    </>
  );
}
